import { Calendar } from 'lucide-react';

import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import Chip from '@/components/atoms/chip';
import { cn } from '@/helpers/shadCnUtils';
import { Fact } from '@/types';

export const InconsistenciesFact = ({
  fact,
  openDocViewer,
  compressedVersion = false,
  reference,
}: {
  fact: Fact;
  openDocViewer?: (docId: string, factId: string, pageNumber: number) => void;
  compressedVersion?: boolean;
  reference?: string;
}) => {
  return (
    <div
      key={fact.id}
      style={{ '--color': 'rgba(49, 196, 172, 0.3)' } as React.CSSProperties}
      className="rounded-md border-gray-200 bg-white"
    >
      <div className="flex w-full justify-between">
        <div className="-ml-1 flex items-center gap-2 text-xs text-blue-600">
          <div>{reference && <span className="rounded-full border bg-gray-50 py-0.5">[{reference}]</span>}</div>

          {/* for now, only show the first doc */}
          {fact.locations && fact.locations.length > 0 && (
            <>
              {fact.locations.map((location) => {
                return (
                  <div key={location.doc?.id} className="flex items-center gap-2">
                    <span
                      data-tooltip-id={`fact-document-tooltip-${fact.id}-${location.doc?.id}`}
                      data-tooltip-content={location.doc?.file?.name}
                      className={!compressedVersion ? 'cursor-pointer' : ''}
                      onClick={(e) => {
                        if (compressedVersion) {
                          return;
                        }
                        e.stopPropagation();
                        if (openDocViewer) {
                          trackCustomEvent(TrackingEvents.OpenDocViewerFromInconsistency);
                          openDocViewer(location.doc?.id ?? '', fact.id, location.boundingBoxes?.[0]?.pageNumber ?? 0);
                        }
                      }}
                    >
                      {location.doc?.file?.name
                        ? location.doc?.file?.name.slice(0, fact.locations.length > 1 ? 12 : 20).trim() + '...'
                        : ''}
                    </span>
                    {location.doc?.type && (
                      <Chip className="bg-brandTertiary/10 text-brandTertiary">{location.doc?.type}</Chip>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className="ml-2 flex justify-end gap-2 text-xs">
          {fact.factDateText && (
            <div className={`flex items-center gap-2 text-gray-600`}>
              <p className="-mb-0.5">{fact.factDateText}</p>
            </div>
          )}
        </div>
      </div>
      <div className="p-1 text-gray-800">{fact.description}</div>
    </div>
  );
};
